var landscapeWidth = 20 * 1.7;
var handleAspectRatio = function (ratio) {
    var aspectRatio = "";
    switch (ratio) {
        case "16*9":
        case "16x9":
            aspectRatio = "r16x9";
            break;
        case "9*16":
        case "9x16":
            aspectRatio = "r9x16";
            break;
        case "1*1":
            aspectRatio = "r1x1";
            break;
        case "3*4":
            aspectRatio = "r3x4";
            break;
        case "4*3":
            aspectRatio = "r4x3";
            break;
        case "32*9":
            aspectRatio = "r32x9";
            break;
        default:
            aspectRatio = "";
    }
    return aspectRatio;
};
export var handleImpolicyResolution = function (ratio) {
    var resolution = { w: 1920, h: 1080, type: "placeholderCover" };
    switch (ratio) {
        case "16*9":
            resolution = { w: 1920, h: 1080, type: "placeholderCover" };
            break;
        case "1*1":
            resolution = { w: 1080, h: 1080, type: "placeholderPoster" };
            break;
        case "3*4":
            resolution = { w: 1080, h: 1440, type: "placeholderPoster" };
            break;
        default:
            resolution = { w: 1920, h: 1080, type: "placeholderCover" };
    }
    return resolution;
};
export var getlazyLoadSrc = function (ratio, item) {
    var _a, _b, _c, _d, _e, _f;
    var aspectRatio = handleAspectRatio(ratio);
    var type = handleImpolicyResolution(ratio).type;
    var url = ((_b = (_a = item === null || item === void 0 ? void 0 : item.gist) === null || _a === void 0 ? void 0 : _a.imageGist) === null || _b === void 0 ? void 0 : _b["".concat(aspectRatio)]) ? "".concat((_c = item === null || item === void 0 ? void 0 : item.gist) === null || _c === void 0 ? void 0 : _c.imageGist["".concat(aspectRatio)], "?impolicy=resize&w=80&h=80") : "".concat((_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.appcmsMain) === null || _e === void 0 ? void 0 : _e.images) === null || _f === void 0 ? void 0 : _f[type], "?impolicy=resize&w=80&h=80");
    return url;
};
export var getSrc = function (ratio, item) {
    var _a, _b, _c, _d, _e, _f;
    var aspectRatio = handleAspectRatio(ratio);
    var _g = handleImpolicyResolution(ratio), w = _g.w, h = _g.h, type = _g.type;
    var url = ((_b = (_a = item === null || item === void 0 ? void 0 : item.gist) === null || _a === void 0 ? void 0 : _a.imageGist) === null || _b === void 0 ? void 0 : _b["".concat(aspectRatio)]) ? "".concat((_c = item === null || item === void 0 ? void 0 : item.gist) === null || _c === void 0 ? void 0 : _c.imageGist["".concat(aspectRatio)], "?impolicy=resize&w=").concat(w, "&h=").concat(h) : "".concat((_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.app_data) === null || _d === void 0 ? void 0 : _d.appcmsMain) === null || _e === void 0 ? void 0 : _e.images) === null || _f === void 0 ? void 0 : _f[type], "?impolicy=resize&w=1920&h=1080");
    return url;
};
